import {TranslatableRental} from "./locations";
import {mainPhotoRoom, roomPhotos} from "./photo";
import {roomFR} from "./descriptions/fr/room";
import {roomEN} from "./descriptions/en/room";

export const chambre1: TranslatableRental = {
  roomId: "605502",
  slugs: {
    fr: "chambre-double-numero-1",
    en: "standard-double-room-number-1"
  },
  name: {
    fr: "Chambre double",
    en: "Double room"
  },
  area: 22,
  capacity: 2,
  numberOfBeds: 1,
  numberOfBedrooms: 1,
  numberOfBathrooms: 1,
  description: {
    fr: roomFR,
    en: roomEN
  },
  lodgifyId: "538838",
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "heater",
    "swimming",
    "toilet",
    "shower",
    "parking",
    "hair-dryer",
    "no-smoking",
    "household-linen"
  ],
  assets: roomPhotos,
  mainImage: mainPhotoRoom
};
